import { writable } from "svelte/store";
export class ToolBoxManager {
    constructor(options) {
        this.readyEvents = [];
        this.options = options;
        this.openToolBoxStore = writable(this.options.initialView);
    }
    getOpenToolBoxStore() {
        return this.openToolBoxStore;
    }
    async initialize(element) {
        this.element = element;
        console.log(this.element);
    }
    addToMap(map) {
        console.log("add to map on toolbox manager");
        this.mapManager = map;
        this.mapManager.addControl(this, this.options.position);
    }
    on(event, callback) {
        this.readyEvents.push(callback);
    }
    _raise(event) {
        this.readyEvents.forEach(x => x());
    }
    getMap() {
        return this.map;
    }
    onAdd(map) {
        this.map = map;
        this._raise("ready");
        return this.element;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/no-empty-function
    onRemove(map) {
    }
}
